var React = require('react');

function SocialInstagram (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"currentColor","d":"M352,0H160C71.6,0,0,71.6,0,160v192c0,88.4,71.6,160,160,160h192c88.4,0,160-71.6,160-160V160C512,71.6,440.4,0,352,0z\n\t M464,352c0,61.8-50.2,112-112,112H160c-61.8,0-112-50.2-112-112V160C48,98.2,98.2,48,160,48h192c61.8,0,112,50.2,112,112V352z","key":0}),React.createElement("path",{"fill":"currentColor","d":"M256,128c-70.7,0-128,57.3-128,128s57.3,128,128,128s128-57.3,128-128S326.7,128,256,128z M256,336c-44.1,0-80-35.9-80-80\n\tc0-44.1,35.9-80,80-80s80,35.9,80,80C336,300.1,300.1,336,256,336z","key":1}),React.createElement("circle",{"fill":"currentColor","cx":"393.6","cy":"118.4","r":"17.1","key":2})]);
}

SocialInstagram.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 512 512","enableBackground":"new 0 0 512 512","xmlSpace":"preserve"};

module.exports = SocialInstagram;

SocialInstagram.default = SocialInstagram;
